module.exports = __webpack_public_path__ + "static/img/supervisor_icon.e6e1b5ed.png";